import * as React from "react";
const SvgHelp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeWidth={1.375}
      d="M14.438 7.992a.43.43 0 0 1 .43-.43h1.288c.95 0 1.719.77 1.719 1.72v4.296c0 .95-.77 1.719-1.719 1.719h-1.289a.43.43 0 0 1-.43-.43zM4.125 7.992a.43.43 0 0 0-.43-.43H2.406c-.949 0-1.718.77-1.718 1.72v4.296c0 .95.769 1.719 1.718 1.719h1.29a.43.43 0 0 0 .429-.43z"
    />
    <rect
      width={3.438}
      height={2.578}
      stroke="#89909D"
      strokeWidth={1.375}
      rx={0.43}
      transform="matrix(-1 0 0 1 11 18.734)"
    />
    <path
      stroke="#89909D"
      strokeWidth={1.375}
      d="M16.156 7.563a6.875 6.875 0 1 0-13.75 0M16.156 15.297c0 3.797-1.359 4.726-5.156 4.726"
    />
  </svg>
);
export default SvgHelp;
